<template>
  <div>
    <app-loader v-if="loading" />
    <div
      v-for="(item, index) in sortedArticles.slice(0, articlesCount)"
      :key="item.index"
      class="news__item"
    >
      <div class="row">
        <div class="col-12">
          <p class="gray-text text-small font-weight-light mb-1">
            {{ item.datum }}
          </p>
          <strong class="d-block font-weight-bolder mb-1">{{
            item.nadpis
          }}</strong>
          <div class="news__perex">
            <p class="mb-0 font-weight-light">
              <span v-html="item.perex" /><span class="d-none">{{
                index
              }}</span>
            </p>
          </div>
          <div class="news__more text-right">
            <router-link
              :to="{
                name: 'article-detail',
                params: {
                  id: item.id,
                  customerId: customerId,
                  projectId: projectId
                },
                query: { url: item.url }
              }"
            >
              {{ $t("vice") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="moreButton && articlesCount < sortedArticles.length"
      class="d-flex"
    >
      <button
        class="btn d-flex align-items-center btn-primary my-3 mr-3"
        @click="articlesCount += 1"
      >
        <div class="atom-icon">
          <img src="@/assets/icons/actions/ico-btn-nova.svg" />
        </div>
        {{ $t("zobrazitDalsiNovinky") }}
      </button>
      <button
        v-if="articlesCount < sortedArticles.length"
        class="btn btn-outline-primary my-3"
        @click="articlesCount = sortedArticles.length"
      >
        {{ $t("zobrazitVsechnyNovinky") }}
      </button>
    </div>
  </div>
</template>

<script>
//import axios from "axios";
import _ from "lodash";
import Loader from "@/components/loader.vue";
export default {
  components: {
    "app-loader": Loader
  },
  props: {
    items: Array,
    loading: Boolean,
    moreButton: Boolean
  },
  data() {
    return {
      articlesCount: 3,
      projectId: JSON.parse(localStorage.getItem("selectedProject")).projectId,
      customerId: JSON.parse(localStorage.getItem("selectedCustomer"))
        .customerId
    };
  },
  computed: {
    sortedArticles() {
      return _.orderBy(this.items, "datum", "desc");
    },
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      //this.loadPosts();
    }
  },
  created() {},
  mounted() {
    //this.loadPosts();
  },
  methods: {
    /*loadPosts() {
      this.items = [];
      !this.loading ? (this.loading = true) : (this.loading = false);

      axios
        .get(
          process.env.VUE_APP_APICMS +
            "/" +
            this.locale +
            "/article/dashboard",
          {
            crossdomain: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            this.items = response.data;
          } else {
            this.items = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.items = [];
        });
    }*/
  }
};
</script>

<style scoped></style>
